function clearDetailsLocalStorage() {
  localStorage.removeItem('user');
  localStorage.removeItem('company');
  localStorage.removeItem('token');
}

export { clearDetailsLocalStorage };